import { Button, Group, Stack } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { Declarant } from '@e-origin/shared';

import { useDuplicateDeclarant } from '@admin/hooks';
import { TextInput } from '@components';

interface DuplicateDeclarantProps {
  declarant: Declarant;
}

export const DuplicateDeclarant: React.FC<DuplicateDeclarantProps> = ({ declarant }) => {
  const [declarantAccountName, setDeclarantAccountName] = useState(`DUPL_${declarant.accountName}`);
  const [declarantName, setDeclarantName] = useState(`DUPL_${declarant.name}`);
  const duplicateDeclarantMutation = useDuplicateDeclarant();

  const handleDuplicate = async () => {
    await duplicateDeclarantMutation.mutateAsync({
      ...declarant,
      accountName: declarantAccountName,
      name: declarantName,
      _id: null,
      createdAt: null,
      updatedAt: null,
      default: false,
      goodsLocations: [],
      users: [],
      linkedBrokers: [],
      linkedSellers: [],
    });

    modals.closeAll();
  };

  return (
    <Stack>
      <TextInput label="Declarant name" value={declarantName} onChange={(event) => setDeclarantName(event.target.value)} />
      <TextInput label="Declarant account name" value={declarantAccountName} onChange={(event) => setDeclarantAccountName(event.target.value)} />
      <Group justify="center" mt="md">
        <Button type="button" onClick={handleDuplicate} variant="filled" size="lg">
          Duplicate
        </Button>
      </Group>
    </Stack>
  );
};
